module.exports = __webpack_public_path__ + "124c1aff37431c672c39ab1ca1117548.jpg";